export { default as SerpSeasonEndSlot } from './SerpSeasonEndSlot';
